// @ts-nocheck
import type { Question } from '../types';

export const emergencyProceduresQuestions: Question[] = [
  {
    id: 'q-ep-1',
    topic: 'General',
    question: 'What should you do if you are involved in a traffic accident?',
    options: [
      { id: 'q-ep-1o1', text: 'Drive away quickly' },
      { id: 'q-ep-1o2', text: 'Stop immediately and check for injuries' },
      { id: 'q-ep-1o3', text: 'Wait for someone else to call the police' }
    ],
    answerId: 'q-ep-1o2',
    explanation: 'If you are involved in a traffic accident, you must stop immediately and check for injuries. Call emergency services if needed.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-2',
    topic: 'General',
    question: 'What is the emergency number in the Netherlands?',
    options: [
      { id: 'q-ep-2o1', text: '911' },
      { id: 'q-ep-2o2', text: '112' },
      { id: 'q-ep-2o3', text: '999' }
    ],
    answerId: 'q-ep-2o2',
    explanation: 'The emergency number in the Netherlands is 112. This number connects you to police, fire, and ambulance services.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-3',
    topic: 'General',
    question: 'When should you call the emergency number 112?',
    options: [
      { id: 'q-ep-3o1', text: 'Only for life-threatening situations' },
      { id: 'q-ep-3o2', text: 'For any traffic accident' },
      { id: 'q-ep-3o3', text: 'For life-threatening situations and serious accidents' }
    ],
    answerId: 'q-ep-3o3',
    explanation: 'Call 112 for life-threatening situations and serious accidents where immediate assistance is needed.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-4',
    topic: 'General',
    question: 'What should you do if you witness a traffic accident?',
    options: [
      { id: 'q-ep-4o1', text: 'Continue driving' },
      { id: 'q-ep-4o2', text: 'Stop and offer assistance if safe to do so' },
      { id: 'q-ep-4o3', text: 'Call the police immediately' }
    ],
    answerId: 'q-ep-4o2',
    explanation: 'If you witness a traffic accident, stop and offer assistance if it is safe to do so. Call emergency services if needed.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-5',
    topic: 'General',
    question: 'What should you do if your vehicle breaks down on a motorway?',
    options: [
      { id: 'q-ep-5o1', text: 'Stay in your vehicle' },
      { id: 'q-ep-5o2', text: 'Get out and stand behind the barrier' },
      { id: 'q-ep-5o3', text: 'Walk along the motorway to find help' }
    ],
    answerId: 'q-ep-5o2',
    explanation: 'If your vehicle breaks down on a motorway, get out and stand behind the safety barrier. Use emergency phones to call for assistance.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-6',
    topic: 'General',
    question: 'What should you do if you see an emergency vehicle with lights and sirens?',
    options: [
      { id: 'q-ep-6o1', text: 'Ignore it and continue driving' },
      { id: 'q-ep-6o2', text: 'Move to the right and slow down' },
      { id: 'q-ep-6o3', text: 'Speed up to get out of the way' }
    ],
    answerId: 'q-ep-6o2',
    explanation: 'If you see an emergency vehicle with lights and sirens, move to the right and slow down to allow it to pass safely. (RVV 1990 art. 91)',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-7',
    topic: 'General',
    question: 'What should you do if you are involved in a minor accident with no injuries?',
    options: [
      { id: 'q-ep-7o1', text: 'Exchange information with the other driver' },
      { id: 'q-ep-7o2', text: 'Call the police immediately' },
      { id: 'q-ep-7o3', text: 'Drive away quickly' }
    ],
    answerId: 'q-ep-7o1',
    explanation: 'In a minor accident with no injuries, exchange information with the other driver including names, addresses, and insurance details.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-8',
    topic: 'General',
    question: 'What should you do if you hit a parked car?',
    options: [
      { id: 'q-ep-8o1', text: 'Leave a note with your contact information' },
      { id: 'q-ep-8o2', text: 'Wait for the owner to return' },
      { id: 'q-ep-8o3', text: 'Call the police immediately' }
    ],
    answerId: 'q-ep-8o1',
    explanation: 'If you hit a parked car, leave a note with your contact information and report the incident to your insurance company.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-9',
    topic: 'General',
    question: 'What should you do if you are involved in an accident with a cyclist or pedestrian?',
    options: [
      { id: 'q-ep-9o1', text: 'Drive away quickly' },
      { id: 'q-ep-9o2', text: 'Stop immediately and call emergency services' },
      { id: 'q-ep-9o3', text: 'Wait for someone else to help' }
    ],
    answerId: 'q-ep-9o2',
    explanation: 'If you are involved in an accident with a cyclist or pedestrian, stop immediately and call emergency services (112).',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-10',
    topic: 'General',
    question: 'What should you do if your vehicle catches fire?',
    options: [
      { id: 'q-ep-10o1', text: 'Try to put out the fire yourself' },
      { id: 'q-ep-10o2', text: 'Stop immediately and evacuate everyone' },
      { id: 'q-ep-10o3', text: 'Continue driving to find help' }
    ],
    answerId: 'q-ep-10o2',
    explanation: 'If your vehicle catches fire, stop immediately and evacuate everyone from the vehicle. Call emergency services and move to a safe distance.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-11',
    topic: 'General',
    question: 'What should you do if you witness a hit-and-run accident?',
    options: [
      { id: 'q-ep-11o1', text: 'Follow the fleeing vehicle' },
      { id: 'q-ep-11o2', text: 'Call the police and provide details' },
      { id: 'q-ep-11o3', text: 'Ignore it' }
    ],
    answerId: 'q-ep-11o2',
    explanation: 'If you witness a hit-and-run accident, call the police and provide as many details as possible about the fleeing vehicle.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-12',
    topic: 'General',
    question: 'What should you do if you are involved in an accident with an uninsured driver?',
    options: [
      { id: 'q-ep-12o1', text: 'Accept cash payment' },
      { id: 'q-ep-12o2', text: 'Call the police and your insurance company' },
      { id: 'q-ep-12o3', text: 'Drive away quickly' }
    ],
    answerId: 'q-ep-12o2',
    explanation: 'If you are involved in an accident with an uninsured driver, call the police and your insurance company immediately.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-13',
    topic: 'General',
    question: 'What should you do if your vehicle suddenly loses brake pressure while driving?',
    options: [
      { id: 'q-ep-13o1', text: 'Pump the brake pedal repeatedly and use the handbrake gradually' },
      { id: 'q-ep-13o2', text: 'Accelerate to increase control' },
      { id: 'q-ep-13o3', text: 'Shift to neutral and coast' }
    ],
    answerId: 'q-ep-13o1',
    explanation: 'If brake pressure is lost, pump the brake pedal repeatedly to restore pressure. Use the handbrake gradually to slow the vehicle. Try to reach a safe stopping area and call for assistance.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-14',
    topic: 'General',
    question: 'What should you do if your brakes fail completely while driving downhill?',
    options: [
      { id: 'q-ep-14o1', text: 'Shift to a lower gear and use the handbrake gradually' },
      { id: 'q-ep-14o2', text: 'Speed up to clear the slope' },
      { id: 'q-ep-14o3', text: 'Shift to neutral to reduce drag' }
    ],
    answerId: 'q-ep-14o1',
    explanation: 'If brakes fail downhill, shift to a lower gear to use engine braking and apply the handbrake gradually. Never shift to neutral. Look for a safe place to slow down, such as an escape lane or safe area.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-15',
    topic: 'General',
    question: 'What should you do if your vehicle goes into a skid on a wet or icy road?',
    options: [
      { id: 'q-ep-15o1', text: 'Brake hard to regain control' },
      { id: 'q-ep-15o2', text: 'Steer in the direction you want the back to go and ease off the accelerator' },
      { id: 'q-ep-15o3', text: 'Accelerate to straighten out' }
    ],
    answerId: 'q-ep-15o2',
    explanation: 'In a skid, remain calm and steer in the direction you want the back of the vehicle to go. Ease off the accelerator but do not brake suddenly. Once control is regained, continue carefully.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-16',
    topic: 'General',
    question: 'What should you do if your steering fails while driving?',
    options: [
      { id: 'q-ep-16o1', text: 'Continue driving and try to steer with the wheel' },
      { id: 'q-ep-16o2', text: 'Pull over safely using the handbrake and call for assistance' },
      { id: 'q-ep-16o3', text: 'Accelerate to gain control' }
    ],
    answerId: 'q-ep-16o2',
    explanation: 'If steering fails, pull over safely using the handbrake to slow down gradually. Use gentle movements and try to avoid sudden changes. Call for assistance immediately.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-17',
    topic: 'General',
    question: 'What should you do if you have a flat tire while driving at high speed?',
    options: [
      { id: 'q-ep-17o1', text: 'Brake hard immediately' },
      { id: 'q-ep-17o2', text: 'Reduce speed gradually, maintain steering control, and move to the side of the road' },
      { id: 'q-ep-17o3', text: 'Swerve to avoid the tire' }
    ],
    answerId: 'q-ep-17o2',
    explanation: 'With a flat tire, reduce speed gradually and maintain firm steering control. Do not brake hard as this can cause loss of control. Move safely to the side of the road before stopping.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-18',
    topic: 'General',
    question: 'What is the proper procedure after a minor traffic accident if no one is injured?',
    options: [
      { id: 'q-ep-18o1', text: 'Exchange details and insurance information' },
      { id: 'q-ep-18o2', text: 'Take photos of vehicle damage and location' },
      { id: 'q-ep-18o3', text: 'All of the above' }
    ],
    answerId: 'q-ep-18o3',
    explanation: 'After a minor accident with no injuries, exchange names, addresses, phone numbers, and insurance details. Take photos of all vehicle damage and the accident location. Report to your insurance company.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-19',
    topic: 'General',
    question: 'What should you do if a pedestrian is hit by your vehicle?',
    options: [
      { id: 'q-ep-19o1', text: 'Leave the scene quickly' },
      { id: 'q-ep-19o2', text: 'Stop immediately, provide assistance, and call emergency services' },
      { id: 'q-ep-19o3', text: 'Move the injured person to the side of the road' }
    ],
    answerId: 'q-ep-19o2',
    explanation: 'If you hit a pedestrian, stop immediately and call emergency services (112). Provide assistance if safe to do so but do not move the injured person unless they are in immediate danger. Stay at the scene.',
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-20',
    topic: 'General',
    question: 'What is the emergency number to call in the Netherlands for medical, fire, or police emergencies?',
    options: [
      { id: 'q-ep-20o1', text: '911' },
      { id: 'q-ep-20o2', text: '112' },
      { id: 'q-ep-20o3', text: '999' }
    ],
    answerId: 'q-ep-20o2',
    explanation: 'The universal emergency number in the Netherlands is 112. This number connects to police, fire, ambulance, and other emergency services. You can call 112 from any phone, including mobile phones.',
    subject: 'Emergency Procedures'
  }
];
